import { MapLatLng } from "./map.latlng";

export class MapItinerary {
    map: any;
    fromElem: any;
    toElem: any;
    resultElem: any;

    constructor(map: any, fromId: string, toId: string, resultId: string) {
        this.map = map;
        this.fromElem = document.getElementById(fromId);
        this.toElem = document.getElementById(toId);
        this.resultElem = document.getElementById(resultId);
    }

    setOrigen(pos: MapLatLng) {
    }

    setDestino(pos: MapLatLng) {
    }

    getOrigen(): MapLatLng {
        return null as any;
    }

    getDestino(): MapLatLng {
        return null as any;
    }

    calcItinerary() {
    }

    public remove() {
    }
}
